// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2186":"1625f351","4509":"c8def894","5787":"20d009b5","6904":"b6c9bf7e"}[chunkId] + ".chunk.css";
};